<template>
  <div class="fixed top-0 left-0 w-screen h-full bg-white">
    <page class="h-full">
      <template #rightBtn>
        <img
          src="../../../assets/common/close-icon.svg"
          alt="menu"
          @click="$emit('clear-active-page')"
        />
      </template>
      <template #content>
        <div class="title text-xl">{{ $t('login.login_title') }}</div>
        <div class="mb-5 text-xl">{{ $t('login.login_email_title') }}</div>
        <div
          class="purple-round-input input-wrapper relative mb-5 rounded-sm"
          :class="{ focus: focusStatus === 'account' }"
        >
          <input
            class="w-full h-12 pl-6 outline-none"
            type="email"
            autofocus
            v-model="account"
            :placeholder="$t('login.enter_email_address')"
            @click="focusStatus = 'account'"
          />
        </div>
        <div
          class="purple-round-input input-wrapper relative rounded-sm"
          :class="{ focus: focusStatus === 'password' }"
        >
          <input
            class="w-full h-12 pl-6 outline-none"
            :type="inputType"
            v-model="password"
            :placeholder="$t('login.password')"
            @click="focusStatus = 'password'"
            @keyup.enter="login"
          />
          <img
            v-if="isHide"
            class="eye-icon absolute"
            src="../../../assets/common/eye.svg"
            @click="isHide = !isHide"
          />
          <img
            v-else
            class="eye-icon absolute"
            src="../../../assets/common/black-eye.svg"
            @click="isHide = !isHide"
          />
        </div>
        <div class="forget-text mt-1 text-xs text-right underline" @click="isShow = true">
          {{ $t('login.forget_password') }}
        </div>
        <c-button :confirmed-status="confirmedStatus" class="relative mt-12" @click="login">
          <span>{{ $t('login.login') }}</span>
        </c-button>
        <error-message v-if="errorMsg" :message="errorMsg" />
      </template>
    </page>
    <forget-pwd
      v-if="isShow"
      :type="'email'"
      :is-show.sync="isShow"
      @clear-active-page="$emit('clear-active-page')"
    />
  </div>
</template>

<script>
import ApiActions from '@/modules/api-actions';
import loginError from '@/mixins/login-error';
import Page from '@/components/common/Page.vue';
import CButton from '@/components/common/CButton.vue';
import ForgetPwd from './ForgetPwd.vue';
import ErrorMessage from '../common/ErrorMessage.vue';

export default {
  mixins: [loginError],
  components: {
    Page,
    CButton,
    ForgetPwd,
    ErrorMessage,
  },
  data() {
    return {
      account: '',
      password: '',
      isHide: true,
      errorMsg: null,
      isShow: false,
      focusStatus: 'account',
    };
  },
  computed: {
    inputType() {
      return this.isHide ? 'password' : 'text';
    },
    confirmedStatus() {
      const emailRegExp = /^\w+((-\w+)|(\.\w+)|(\+\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
      return this.password.length > 3 && emailRegExp.test(this.account);
    },
  },
  methods: {
    async login() {
      if (!this.confirmedStatus) return;
      this.$events.startLoading();

      try {
        await ApiActions.user.login({
          username: this.account,
          password: this.password,
          provider: 0,
        });
        this.$emit('done');
      } catch (e) {
        this.errorMsg = this.handleLoginError(e);
        this.$events.stopLoading();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  color: #572bff;
}

.input-wrapper {
  width: 309px;
}

.forget-text {
  width: 309px;
}

.eye-icon {
  top: 50%;
  right: 21px;
  transform: translateY(-50%);
}
</style>
